<template>
  <div class="student-class-card mr-2">
    <v-row v-if="classInfo.class_type === 'tutor'">
      <v-col cols="9">
        <div class="d-flex align-center mb-2">
          <v-icon
            small
            class="mr-2"
          >
            mdi-book-open-blank-variant
          </v-icon>
          <b v-if="classInfo.class_type === 'tutor'">{{classInfo.name}}</b>
          <b v-if="classInfo.class_type === 'duo'">
            {{ classInfo.className }}<span style="color: #F2994A" class="text-uppercase ml-4">{{ classInfo.level }}</span>
          </b>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon
            small
            class="mr-2"
          >
            mdi-town-hall
          </v-icon>
          <b :style="`color: ${classInfo.status_color}`" v-if="classInfo.class_type === 'tutor'">{{classInfo.status_name}}
            <span v-if="classInfo.join_date">| Ngày vào lớp: {{formatDateSlash(classInfo.join_date)}}</span>
          </b>
          <b v-else>
            <span v-if="classInfo.status" :style="'font-weight:600; color:' + (STATUS_COURSES.find((e) => e.status === classInfo.status) ? STATUS_COURSES.find((e) => e.status === classInfo.status).color : '#000000')">
                      {{ classInfo.status }}
            </span>
          </b>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon
            small
            class="mr-2"
          >
            mdi-calendar-month-outline
          </v-icon>
          <div v-if="classInfo.class_schedule && classInfo.class_type === 'tutor'">
            <div v-for="(item, n) in JSON.parse(classInfo.class_schedule)" :key="item.name + n">
              <span v-for="(schedule, n) in item.schedule" :key="schedule.day + n">
                {{schedule.time}} ({{schedule.day}})
              </span>
            </div>
          </div>
          <div v-if="classInfo.class_type === 'duo'">
            Ngày diễn ra: {{getFormatDateLessonDetail(classInfo.classStartDate)}}
          </div>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon
            small
            class="mr-2"
          >
            mdi-calendar-remove-outline
          </v-icon>
          <div v-if="classInfo.class_type === 'tutor'">
            GV dạy:
            <span v-if="classInfo.teacher_full_name">{{classInfo.teacher_full_name}}</span>
            <span v-else style="margin-left: 12px">  ---</span>
          </div>
          <div v-if="classInfo.class_type === 'duo'">
            Ngày hết hạn:
            <span class="red--text">
              {{getFormatDateLessonDetail(classInfo.courseEndDate)}}
            </span>
          </div>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon
            small
            class="mr-2"
          >
            mdi-calendar-remove-outline
          </v-icon>
          <div v-if="classInfo.class_type === 'tutor'">
            Đã học: {{classInfo.number_lessons_passed}}/{{classInfo.number_lessons}} (buổi)
          </div>
          <div v-if="classInfo.class_type === 'duo'">
            Lần cuối vào học: <span class="red--text">{{getFormatDateLessonDetail(classInfo.lastLogin)}}</span>
          </div>
        </div>
      </v-col>
      <v-col cols="3" style="text-align:end">
        <div class="more"  v-if="classInfo.class_type === 'tutor' && checkOnleaveAndReversePermission()">
          <v-menu offset-y transition="slide-x-transition" bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="goToClassScheduling(classInfo)">
                <v-list-item-title>
                  <v-icon>mdi-information</v-icon> Thông tin chi tiết học viên
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="checkConditionShowTicket(classInfo)" @click="showPopupOnLeave(classInfo)">
                <v-list-item-title>
                  <v-icon>mdi-calendar</v-icon> Nghỉ phép
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="checkConditionShowTicket2(classInfo)" @click="showPopupReserve(classInfo)">
                <v-list-item-title>
                  <v-icon>mdi-account-box</v-icon> Bảo lưu
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="isReserve(classInfo)" @click="showPopupLearnAgain(classInfo)">
                <v-list-item-title>
                  <v-icon>mdi-account-box</v-icon> Đi học lại
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex justify-end">
          <div class="gh-tutor mr-0" v-if="classInfo.class_type === 'tutor'">
          TUTOR
          </div>
          <div class="gh-duo mr-0" v-if="classInfo.class_type === 'duo'">
            DUO
          </div>
        </div>
      </v-col>
    </v-row >
    <div v-else class="class-studying">
      <div v-if="classInfo.duo_class_type === DUO_CLASS_TYPE.SELF_STUDY" class="class-studying-item">
        <div class="mb-2 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <img src="../../duo_care/assets/book-open.svg" width="16" height="16" alt="" class="mr-2">
            <b style="font-weight: 700">
              <span class="text-uppercase mr-4">{{ classInfo.className }}</span>
              <span style="color: #F2994A" class="text-uppercase">{{ classInfo.classLevel }}</span>
            </b>
          </div>
          <div class="gh-duo ml-2">
            DUO
          </div>
        </div>
        <div class="mb-2 d-flex align-center">
          <img src="../../duo_care/assets/school.svg" width="16" height="16" alt="" class="mr-2">
          <span>
                    <span v-if="classInfo.classStatus" :style="'font-weight:600; color:' + (STATUS_COURSES.find((e) => e.status === classInfo.classStatus) ? STATUS_COURSES.find((e) => e.status === classInfo.classStatus).color : '#000000')">
                      {{ classInfo.classStatus }}
                    </span>
                  </span>
        </div>
        <div class="mb-2 d-flex align-center">
          <img src="../../duo_care/assets/video.svg" width="16" height="16" class="mr-2" alt="">
          <span >Video đã xem: {{ classInfo.totalVideoViewed }}/{{classInfo.totalVideo}}</span>
        </div>
        <div class="mb-2 d-flex align-center">
          <img src="../../duo_care/assets/homework.svg" width="16" height="16" class="mr-2" alt="">
          <span >Bài tập hoàn thành: {{ classInfo.totalHomeworkCompleted }}/{{classInfo.totalHomework}}</span>
        </div>
        <div class="mb-2 d-flex align-center">
          <img src="../../duo_care/assets/calendar-xmark.svg" width="16" height="16" class="mr-2" alt="">
          <span >
                    Ngày hết hạn: <span class="red--text">{{ classInfo.classEndDate ? classInfo.classEndDate : '' }}</span>
                  </span>
        </div>
        <div class="d-flex align-center">
          <img src="../../duo_care/assets/last-join.svg" width="16" height="16" class="mr-2" alt="">
          <span >
                    Lần cuối vào học: <span>{{ classInfo.classLastJoinDate ? classInfo.classLastJoinDate : '' }}</span>
                  </span>
        </div>
      </div>
      <div v-if="classInfo.duo_class_type === DUO_CLASS_TYPE.DUO_CLASS" class="class-studying">
        <div class="class-studying-item">
          <div class="mb-2 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <img
                src="../../duo_care/assets/book-open.svg"
                width="16"
                height="16"
                alt=""
                class="mr-2"
              />
              <b style="font-weight: 700">
                <span class="text-uppercase mr-4">{{ classInfo.className }}</span>
                <span style="color: #f2994a" class="text-uppercase">{{
                    classInfo.classLevel
                  }}</span>
              </b>
            </div>
            <div class="gh-duo ml-2">
              DUO
            </div>
          </div>
          <div class="mb-2 d-flex align-center">
            <img
              src="../../duo_care/assets/school.svg"
              width="16"
              height="16"
              alt=""
              class="mr-2"
            />
            <span>
                <span
                  v-if="classInfo.classStatus"
                  :style="
                    'font-weight:600; color:' +
                    (checkStatusClass(classInfo)
                      ? checkStatusClass(classInfo).color
                      : '#000000')
                  "
                >
                  {{ classInfo.classStatus }}
                  <span v-if="classInfo.dateClassStatus && checkStatusClass(classInfo) && checkStatusClass(classInfo).key" style="font-weight: 400;">
                    ({{checkStatusClass(classInfo) ? checkStatusClass(classInfo).key : ''}}: {{classInfo.dateClassStatus}})
                  </span>
                <v-tooltip v-if="classInfo.tooltipText" right>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                    >
                      <v-icon size="16" class="mx-2">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span v-html="classInfo.tooltipText"></span>
                </v-tooltip>
                </span>
              </span>
          </div>
          <div class="mb-2 d-flex align-center">
            <img
              src="../../duo_care/assets/calendar-days.svg"
              width="16"
              height="16"
              class="mr-2"
              alt=""
            />
            <span
            >Ngày vào học:
                {{ classInfo.classJoinDate ? classInfo.classJoinDate : "--" }}</span
            >
          </div>
          <div class="mb-2 d-flex align-center">
            <img
              src="../../duo_care/assets/calendar-xmark.svg"
              width="16"
              height="16"
              class="mr-2"
              alt=""
            />
            <span>
                Ngày hết hạn:
                <span class="red--text">{{
                    classInfo.dateClassStatus ? classInfo.dateClassStatus : "--"
                  }}</span>
              </span>
          </div>
          <div class="mb-2 d-flex align-center">
            <img
              src="../../duo_care/assets/last-join.svg"
              width="16"
              height="16"
              class="mr-2"
              alt=""
            />
            <span>
                Lần cuối vào học:
                <span>{{
                    classInfo.classLastJoinDate ? classInfo.classLastJoinDate : "--"
                  }}</span>
              </span>
          </div>
          <div class="d-flex align-center">
            <img
              src="../../duo_care/assets/calendar-study.svg"
              width="16"
              height="16"
              class="mr-2"
              alt=""
            />
            <span>
                Lịch học:
                <span>{{
                    classInfo.classSchedule ? classInfo.classSchedule : "--"
                  }}</span>
              </span>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="isPopupOnLeave" width="544" persistent>
    <popup-on-leave :detailStudent="detailStudent" :isPopupOnLeave="isPopupOnLeave"/>
  </v-dialog>
  <v-dialog v-model="isPopupReserve" width="544" persistent>
    <popup-reserve :detailStudent="detailStudent" :isPopupReserve="isPopupReserve"/>
  </v-dialog>
  <v-dialog v-if="isPopupLearnAgain" v-model="isPopupLearnAgain" width="544" persistent>
    <popup-learn-again
      :detailStudent="detailStudent"
      :isPopupLearnAgain="isPopupLearnAgain"
      @closePopupLearnAgain="closePopupLearnAgain"
      />
  </v-dialog>
  </div>
</template>

<script>
import { SCHOOL_LEVEL, STATUS_COURSES } from '@/helpers/constant';
import { DUO_CLASS_TYPE } from '@/modules/student_detail_bt/const';
import PopupOnLeave from '@/modules/student_care/components/PopupOnLeave.vue';
import PopupReserve from '@/modules/student_care/components/PopupReserve.vue';
import PopupLearnAgain from '@/modules/student_care/components/PopupLearnAgain.vue';
import moment from 'moment';

export default {
  name: 'StudentClassCard',
  props: {
    classInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: { PopupOnLeave, PopupReserve, PopupLearnAgain },
  data() {
    return {
      DUO_CLASS_TYPE,
      STATUS_COURSES,
      isPopupReserve: false,
      isPopupOnLeave: false,
      isPopupLearnAgain: false,
      detailStudent: {},
    };
  },
  created() {
    Bus.$on('closePopupReserve', () => {
      this.isPopupReserve = false;
    });
    Bus.$on('closePopupOnLeave', () => {
      this.isPopupOnLeave = false;
    });
  },
  methods: {
    checkStatusClass(item) {
      const data = STATUS_COURSES.find((e) => e.status === item.classStatus);
      if (data) {
        return data;
      }
      return null;
    },
    isExpireActiveDate(activeDate) {
      return moment(new Date()).isAfter(moment(activeDate));
    },
    checkOnleaveAndReversePermission() {
      const { schoolLevel } = this.$route.query;
      if (schoolLevel === SCHOOL_LEVEL.PRIMARY) {
        return this.checkAuthorization('on-leave-and-reserve-bt_read');
      }
      if (schoolLevel === SCHOOL_LEVEL.SECONDARY) {
        return this.checkAuthorization('on-leave-and-reserve-bt-secondary_read');
      }
      return false;
    },
    goToClassScheduling(item) {
      window.open(`${process.env.VUE_APP_ERP}/tutor/sort/student?studentId=${item.student_id}&teacherTypeId=${item.teacher_type}&classId=${item.class_id}&productId=${item.student_product_id}&contactId=${item.contact_id}`, '_blank');
    },
    checkConditionShowTicket(item) {
      if (
        item.status_name === 'Bảo lưu'
        || item.status_name === 'Hết buổi'
        || item.status_name === 'Đã kết thúc'
        || item.status_name === 'Chờ xếp lớp'
      ) {
        return false;
      }
      return true;
    },
    checkConditionShowTicket2(item) {
      if (
        item.status_name === 'Đang học'
        || item.status_name === 'Chờ khai giảng'
        || item.status_name === 'Chờ chuyển lớp'
        || item.status_name === 'Chờ xếp lớp'
        || item.status_name === 'Chuyển phí'
      ) {
        return true;
      }
      return false;
    },
    isReserve(item) {
      if (
        item.status_name === 'Bảo lưu'
      ) {
        return true;
      }
      return false;
    },
    showPopupReserve(student) {
      this.isPopupReserve = true;
      this.detailStudent = student;
    },
    showPopupOnLeave(student) {
      this.isPopupOnLeave = true;
      this.detailStudent = student;
    },
    showPopupLearnAgain(student) {
      this.isPopupLearnAgain = true;
      this.detailStudent = student;
    },
    closePopupLearnAgain() {
      this.isPopupLearnAgain = false;
    },
  },
};
</script>

<style scoped>
.student-class-card {
  border-radius: 5px;
  border: 1px solid #D2D2D2;
  padding: 12px 16px;
}
.gh-tutor {
  font-size: 10px;
  border-radius: 16px ;
  margin-right: 12px;
  background: #CD91D7;
  padding: 8px 16px;
  color: white;
  width: fit-content;
  height: fit-content;
}
.gh-duo {
  font-size: 10px;
  border-radius: 16px ;
  background: #0180C7;
  padding: 8px 16px;
  color: white;
  width: fit-content;
  height: fit-content;
}
</style>
